/**
 * Copyright (c) 2020
 *
 * Contains the representation of a BillingPortal
 *
 * @summary billingPortal class definition
 * @author Julien <julien.donnadieu@yooda.com>
 *
 * Created at     : 2020-06-08 10:21:56
 * Last modified  : 2021-08-17 15:34:17
 */

import Customer from '@/models/customersManager/entity/Customer'

class BillingPortal {

    /**
     * @type id Integer
     */
    #id

    /**
     * @type url String
     */
    #url

    /**
     * @type createdAt Date
     */
    #createdAt

    /**
     * @type newLinkAvailableAt Date
     */
    #newLinkAvailableAt

    /**
     * @type expiresAt Date
     */
    #expiresAt

    /**
     * @type customer null|Customer
     */
    #customer = null

    /**
     * @param rawBillingPortal null|Object
     */
    constructor(rawBillingPortal = null) {
        if (rawBillingPortal !== null) {
            const { id, url, createdAt, newLinkAvailableAt, expiresAt, customer } = rawBillingPortal
            this.id = id
            this.url = url
            this.createdAt = createdAt
            this.newLinkAvailableAt = newLinkAvailableAt
            this.expiresAt = expiresAt
            this.customer = customer
        }
    }

    /**
     * @returns Integer
     */
    get id () {
        return this.#id
    }

    /**
     * @param id String
     * @returns void
     */
    set id (id) {
        this.#id = parseInt(id)
    }

    /**
     * @returns String
     */
    get url () {
        return this.#url
    }

    /**
     * @param url String
     * @returns void
     */
    set url (url) {
        this.#url = url
    }

    /**
     * @returns Date
     */
    get createdAt () {
        return this.#createdAt
    }

    /**
     * @param createdAt String
     * @returns void
     */
    set createdAt (createdAt) {
        this.#createdAt = new Date(createdAt)
    }

    /**
     * @returns Date
     */
    get newLinkAvailableAt () {
        return this.#newLinkAvailableAt
    }

    /**
     * @param newLinkAvailableAt String
     * @returns void
     */
    set newLinkAvailableAt (newLinkAvailableAt) {
        this.#newLinkAvailableAt = new Date(newLinkAvailableAt)
    }

    /**
     * @returns Date
     */
    get expiresAt () {
        return this.#expiresAt
    }

    /**
     * @param expiresAt String
     * @returns void
     */
    set expiresAt (expiresAt) {
        this.#expiresAt = new Date(expiresAt)
    }

    /**
     * @returns Customer|null
     */
    get customer () {
        return this.#customer
    }

    /**
     * @param rawCustomer null|Object
     * @returns void
     */
    set customer (rawCustomer) {
        this.#customer = null
        if (rawCustomer !== null && typeof rawCustomer !== 'undefined') {
            this.#customer = new Customer(rawCustomer)
        }
    }
}

export default BillingPortal
